/**
 * @fileoverview `<CoteDivoireFlag>` — drapeau vectoriel de la République
 * de Côte d'Ivoire, format aspect-3:2, sans marge propre.
 *
 * Utilisé principalement dans `<PhoneNumberInput>` pour signaler
 * visuellement le pays de rattachement du préfixe `+225`. Couleurs
 * officielles (ordre héraldique : orange à la hampe, blanc, vert) :
 *   - Orange : #F77F00
 *   - Blanc  : #FFFFFF
 *   - Vert   : #009E60
 *
 * @see https://fr.wikipedia.org/wiki/Drapeau_de_la_C%C3%B4te_d%27Ivoire
 */

export interface CoteDivoireFlagProps {
  /**
   * Classe supplémentaire — appliquée sur le `<svg>`. Utiliser pour
   * fixer la taille (`size-5`, `h-4 w-6`, etc.). Sans classe, le SVG
   * hérite de la taille de son parent selon les règles CSS habituelles.
   */
  className?: string;
  /**
   * Libellé accessible du drapeau. Par défaut, le SVG est marqué
   * `aria-hidden` car il est décoratif (le préfixe `+225` textuel
   * porte déjà l'information). Passer un label pour le rendre visible
   * aux lecteurs d'écran (rare cas où le drapeau seul suffit).
   */
  title?: string;
}

export function CoteDivoireFlag({ className, title }: CoteDivoireFlagProps): React.JSX.Element {
  const decorative = !title;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 3 2"
      className={className}
      role={decorative ? undefined : 'img'}
      aria-hidden={decorative || undefined}
      aria-label={title}
      preserveAspectRatio="xMidYMid meet"
    >
      {title && <title>{title}</title>}
      <rect x="0" y="0" width="1" height="2" fill="#F77F00" />
      <rect x="1" y="0" width="1" height="2" fill="#FFFFFF" />
      <rect x="2" y="0" width="1" height="2" fill="#009E60" />
    </svg>
  );
}
